import { useMemo, useState } from "react"

interface BindType {
  onMouseEnter: () => void
  onMouseLeave: () => void
}

export function useHover() {
  const [isHovering, setIsHovering] = useState(false)
  const bind: BindType = useMemo(() => ({
    onMouseEnter: () => setIsHovering(true),
    onMouseLeave: () => setIsHovering(false),
  }), [])
  return [isHovering, bind] as const
}
